module.exports = __webpack_public_path__ + "static/media/man-male-svgrepo-com.c9262eac.svg";